import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { LogEntity, UserAction } from './constant';
import * as constant from "../utils/constant";
import * as storage from "../services/storage";
import { saveUserActivity } from "../services/http/login";

const TrackURLChanges = () => {
    const location = useLocation();
    const prevLocationRef = useRef(null);
    const addNavigationLog = (newLocation) => {
        try {
            let dataToSend = {
                Action: UserAction.NAVIGATE,
                Entity: LogEntity.USER,
                Info: `${newLocation.pathname.replace('/', '')}`
            };
        const profile = storage.getLocalStorage(constant.STORAGE_PROFILE_KEY);
        if(profile && dataToSend?.Info != ""){
            var pageName = decodeURIComponent(dataToSend?.Info.split('/')[0])
            saveUserActivity("Navigate : "+pageName)
        }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!prevLocationRef.current) {
            prevLocationRef.current = location;
            return;
        }

        const prev = prevLocationRef.current;

        if (
            prev.pathname !== location.pathname ||
            prev?.tabname !== location?.tabname
        ) {
            addNavigationLog(location);
            prevLocationRef.current = location;
        }
    }, [location]);

    return null;
};

export default TrackURLChanges;